import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import  withAppStore from 'decorators/withAppStore';

import Paper from 'material-ui/Paper';

import styles from 'styles/components/Widget';

import { KIND } from '-enums';
import { TREE_EVENT, INFO_EVENT } from 'shared/dictionaries/events';

@withStyles(styles)
@withAppStore
@observer
export default class Widget extends Component {

  componentDidMount() {
    if (!window.qborder) return;

    const node = ReactDOM.findDOMNode(this);
    const { widgets, url } = window.qborder;

    url.disable();

    if (!widgets.get(node))
      widgets.add(node);

    this.setUpEvents(widgets.get(node));
  }

  componentDidUpdate() {
    if (!window.qborder) return;

    const node = ReactDOM.findDOMNode(this);
    window.qborder.widgets.get(node).reload();
  }

  @computed
  get isTree() {
    return this.appStore.kind === KIND.TREE;
  }

  @computed
  get commonAttributes() {
    return {
      'data-widget-vendor': 'qborder',
      'data-variant': this.appStore.kind,
      'data-group': this.appStore.group,
      'data-events': this.appStore.events,
      'data-type': this.appStore.type,
      'data-theme': this.appStore.theme,
      'data-date': this.appStore.date,
      'data-api-key': this.appStore.apiKey,
      'data-dominant-mode': this.appStore.dominantMode
    }
  }

  @computed
  get treeWidgetAttributes() {
    return {
      'data-info-code': this.appStore.code,
      'data-dense': this.appStore.dense,
      'data-search-term': this.appStore.searchTerm,
      'data-search-open': this.appStore.searchOpen,
      'data-expanded': this.appStore.expanded,
      'data-close-type': this.appStore.closeType,
      'data-disable-info': this.appStore.disableInfo
    }
  }

  @computed
  get infoWidgetAttributes() {
    return {
      'data-code': this.appStore.code,
      'data-show-title': this.appStore.showTitle,
      'data-collapsed': this.appStore.collapsed
    }
  }

  render() {
    const { classes } = this.props;
    const widgetSettings = Object.assign({}, this.commonAttributes, this.isTree ? this.treeWidgetAttributes : this.infoWidgetAttributes);

    return (
      <Paper elevation={4} square className={ classes.root } { ...widgetSettings } ></Paper>
    );
  }

  setUpEvents(widget) {
    widget.on(TREE_EVENT.EXPAND, ({ expanded }) => this.appStore.expanded = expanded);
    widget.on(TREE_EVENT.COLLAPSE, ({ expanded }) => this.appStore.expanded = expanded);
    widget.on(TREE_EVENT.SHOW_INFO, ({ code }) => this.appStore.code = code);
    widget.on(TREE_EVENT.CLOSE_INFO, () => this.appStore.code = null);
    widget.on(TREE_EVENT.SEARCH_OPEN, () => this.appStore.searchOpen = true);
    widget.on(TREE_EVENT.SEARCH_CLOSE, () => this.appStore.searchOpen = false);
    widget.on(TREE_EVENT.SEARCH, ({ searchTerm }) => this.appStore.searchTerm = searchTerm);
    widget.on(TREE_EVENT.CHANGE_DATE, ({ date }) => this.appStore.date = date);
    widget.on(INFO_EVENT.CHANGE_DATE, ({ date }) => this.appStore.date = date);
    widget.on(INFO_EVENT.EXPAND, () => this.appStore.collapsed = false);
  }

}



// WEBPACK FOOTER //
// ./src/components/Widget.js